import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Stack,
} from "@mui/material";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import GroupsIcon from "@mui/icons-material/Groups";
import DiscountIcon from "@mui/icons-material/Discount";

const WhyChooseUsSection = () => {
  return (
    <>
      <style>{`
        .why-section {
          position: relative;
          padding: 120px 0;
          background-image: url("https://html.themehour.net/kleanix/demo/assets/img/bg/why-3-bg.jpg");
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          overflow: hidden;
        }

        /* Desktop: 2 sections (image left, content right) */
        .why-flex {
          display: grid;
          grid-template-columns: minmax(360px, 1fr) 1fr;
          gap: 70px;
          align-items: center;
        }

        /* LEFT IMAGE AREA */
        .why-left {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 520px;
        }

        .blue-shape {
          position: absolute;
          width: 360px;
          height: 360px;
          background: #0d6efd;
          border-radius: 180px 180px 40px 40px;
          top: 40px;
          z-index: 1;
        }

        .yellow-shape {
          position: absolute;
          width: 360px;
          height: 180px;
          background: #ffcc00;
          bottom: 30px;
          border-radius: 40px 40px 180px 180px;
          z-index: 0;
        }

        .why-left img {
          position: relative;
          z-index: 5;
          width: 100%;
          max-width: 360px;
          height: auto;
          display: block;
        }

        .sparkle {
          position: absolute;
          color: #0d6efd;
          font-size: 22px;
          animation: float 3s ease-in-out infinite;
          z-index: 6;
        }
        .sparkle.one { top: 30px; left: 80px; }
        .sparkle.two { top: 130px; right: 40px; }

        @keyframes float {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        /* RIGHT CONTENT */
        .why-right { position: relative; }

        .why-sub {
          color: #0d6efd;
          font-weight: 700;
          font-size: 14px;
          letter-spacing: 2px;
          margin-bottom: 12px;
          display: inline-block;
        }

        .why-title {
          font-size: 42px;
          font-weight: 800;
          line-height: 1.2;
          margin-bottom: 20px;
          color: #111827;
        }

        .why-text {
          font-size: 16px;
          color: #6b7280;
          line-height: 1.7;
          max-width: 520px;
          margin-bottom: 28px;
        }

        /* FEATURE AREA */
        .feature-area {
          position: relative;
          width: 100%;
          max-width: 520px; /* keep cards area smaller */
          padding-top: 10px;
        }

        /* Blue triangle background (desktop only) */
        .triangle-bg {
          position: absolute;
          top: -6px;
          left: 0;
          width: 0;
          height: 0;
          border-left: 280px solid #0d6efd;
          border-top: 230px solid transparent;
          border-bottom: 230px solid transparent;
         
          z-index: 0;
          pointer-events: none;
        }

        /* Cards layout: 2 in first row, 1 in second row */
        .feature-grid {
          position: relative;
          z-index: 1;
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 22px;
        }

        .feature-card {
          border-radius: 22px;
          box-shadow: 0 20px 50px rgba(0,0,0,0.12);
          overflow: hidden;
          min-width: 0;
        }

        /* force third card to span both columns */
        .feature-card.full {
          grid-column: 1 / -1;
        }

        .feature-card-inner {
          display: flex;
          align-items: flex-start;
          gap: 14px;
        }

        .feat-icon {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          background: #ffcc00;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #111;
          flex: 0 0 46px;
        }

        .feat-title {
          font-size: 16px;
          font-weight: 700;
          margin: 0;
          color: #111827;
          line-height: 1.25;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: anywhere;
          min-width: 0;
        }

        /* MOBILE: column + hide triangle + ensure padding */
        @media (max-width: 900px) {
          .why-section { padding: 80px 0; }

          .why-flex {
            grid-template-columns: 1fr;
            gap: 40px;
          }

          .why-title { font-size: 32px; }

          .triangle-bg { display: none; }

          .feature-area { max-width: 100%; }

          .feature-grid { grid-template-columns: 1fr; }

          .feature-card.full { grid-column: auto; }

        
          .why-section .MuiContainer-root{
            padding-left: 16px !important;
            padding-right: 16px !important;
          }
        }

        @media (max-width: 600px) {
          .blue-shape { width: 300px; height: 300px; }
          .yellow-shape { width: 300px; height: 160px; }
          .why-left img { max-width: 280px; padding:10px }
          .two{ color:yellow;}
        }
      `}</style>

      <Box className="why-section">
        <Container>
          <Box className="why-flex">
            {/* LEFT */}
            <Box className="why-left">
              <span className="sparkle one">✦</span>
              <span className="sparkle two">✦</span>

              <Box className="blue-shape" />
              <Box className="yellow-shape" />

              <img
                src="https://html.themehour.net/kleanix/demo/assets/img/why/why-choose-2-left.png"
                alt="Cleaner"
              />
            </Box>

            {/* RIGHT */}
            <Box className="why-right">
              <Typography className="why-sub">WHY CHOOSE US</Typography>

              <Typography className="why-title">
                The Rite Home Pros Advantage
              </Typography>

              <Typography className="why-text">
                High Standards, Low Prices.Home maintenance shouldn't break the bank. At Rite Home Pros, we noticed a gap in the market: homeowners were forced to choose between quality and affordability. We decided to offer both. By streamlining our operations and employing a team of multi-skilled experts, we provide top-tier Cleaning, HVAC, Roofing, and Restoration services at the guaranteed lowest prices.
              </Typography>

              <Box className="feature-area">
                <Box className="triangle-bg" />

                <Box className="feature-grid">
                  <Card className="feature-card" elevation={0}>
                    <CardContent>
                      <Box className="feature-card-inner">
                        <Box className="feat-icon">
                          <LocalLaundryServiceIcon />
                        </Box>
                        <Stack spacing={0.25} sx={{ minWidth: 0 }}>
                          <Typography component="h4" className="feat-title">
                            Organization Services
                          </Typography>
                        </Stack>
                      </Box>
                    </CardContent>
                  </Card>

                  <Card className="feature-card" elevation={0}>
                    <CardContent>
                      <Box className="feature-card-inner">
                        <Box className="feat-icon">
                          <DiscountIcon />
                        </Box>
                        <Stack spacing={0.25} sx={{ minWidth: 0 }}>
                          <Typography component="h4" className="feat-title">
                            Clean Project Discount
                          </Typography>
                        </Stack>
                      </Box>
                    </CardContent>
                  </Card>

                  <Card className="feature-card full" elevation={0}>
                    <CardContent>
                      <Box className="feature-card-inner">
                        <Box className="feat-icon">
                          <GroupsIcon />
                        </Box>
                        <Stack spacing={0.25} sx={{ minWidth: 0 }}>
                          <Typography component="h4" className="feat-title">
                            Professional Team
                          </Typography>
                        </Stack>
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default WhyChooseUsSection;
